var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReturned(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#16BC86",
    d: "M12.5 13.5L4.5 9l8-4.5V8H18a7 7 0 0 1 6.996 6.76L25 15a7 7 0 0 1-7 7H5a1 1 0 0 1 0-2h13a5 5 0 0 0 0-10h-5.5v3.5z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOCIgaGVpZ2h0PSIyOCIgdmlld0JveD0iMCAwIDI4IDI4Ij4KICAgIDxwYXRoIGZpbGw9IiMxNkJDODYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTEyLjUgMTMuNUw0LjUgOWw4LTQuNVY4SDE4YTcgNyAwIDAgMSA2Ljk5NiA2Ljc2TDI1IDE1YTcgNyAwIDAgMS03IDdINWExIDEgMCAwIDEgMC0yaDEzYTUgNSAwIDAgMCAwLTEwaC01LjV2My41eiIvPgo8L3N2Zz4K";
export { SvgIconReturned as ReactComponent };